var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPills(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "16px",
    viewBox: "0 0 20 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PROD-1395--",
    transform: "translate(-299.000000, -1791.000000)",
    fill: "#70777A",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pills-solid-copy",
    transform: "translate(299.000000, 1791.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.88900575,0 C1.73963561,0 0,1.7503882 0,3.91304348 L0,11.7391304 C0,13.9017857 1.73963561,15.6521739 3.88900575,15.6521739 C6.03837589,15.6521739 7.77801149,13.9017857 7.77801149,11.7391304 L7.77801149,3.91304348 C7.77801149,1.7503882 6.03837589,0 3.88900575,0 Z M5.55572249,7.82608696 L2.222289,7.82608696 L2.222289,3.91304348 C2.222289,2.98718944 2.96883921,2.23602484 3.88900575,2.23602484 C4.80917228,2.23602484 5.55572249,2.98718944 5.55572249,3.91304348 L5.55572249,7.82608696 Z M10.4065627,6.78843168 C10.2850313,6.66614907 10.080164,6.68012422 9.97946653,6.81638199 C8.4065026,9 8.5766466,12.060559 10.5315665,14.0275621 C12.4864863,15.9945652 15.5282444,16.1657609 17.6984485,14.5830745 C17.8373415,14.4817547 17.8477585,14.2756211 17.7262271,14.1533385 L10.4065627,6.78843168 Z M18.3859691,6.1246118 C16.4310493,4.1576087 13.3892912,3.98641304 11.2190871,5.56909938 C11.080194,5.67041925 11.0697771,5.8765528 11.1913085,5.9988354 L18.5109729,13.3637422 C18.6325043,13.4860248 18.8373716,13.4720497 18.9380691,13.3357919 C20.511033,11.1486801 20.3443613,8.09161491 18.3859691,6.1246118 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPills);
export default __webpack_public_path__ + "static/media/icon-pills.3a7b3a8ccee0588c96f7e2d2dd58e05b.svg";
export { ForwardRef as ReactComponent };